import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import { getImageUrl, getImageUrls, processImageFields } from '@/utils/image' // 图片URL处理工具

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false

// 将图片URL处理方法挂载到 Vue 原型上，使其在所有组件中全局可用
Vue.prototype.$getImageUrl = getImageUrl
Vue.prototype.$getImageUrls = getImageUrls
Vue.prototype.$processImageFields = processImageFields

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
